import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BACKEND_URL } from "../../config";

export const leadsApi = createApi({
  reducerPath: "leadsApi",
  keepUnusedDataFor: 300,
  baseQuery: fetchBaseQuery({
    baseUrl: BACKEND_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token;
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getActiveSalesRepHiringManagers: builder.query({
      query: (location) => ({
        url: `/user/portal/active-sales-rep-hiring-managers/${location}`,
        method: "GET",
      }),
    }),
    checkLeadPhone: builder.mutation({
      query: (payload) => ({
        url: "/user/portal/check-lead-phone",
        method: "POST",
        body: payload,
      }),
    }),
    createCollegeLead: builder.mutation({
      query: (payload) => ({
        url: "/user/portal/create-college-lead",
        method: "POST",
        body: payload,
      }),
    }),
    createRepLead: builder.mutation({
      query: (payload) => ({
        url: "/user/portal/create-rep-lead",
        method: "POST",
        body: payload,
      }),
    }),
  }),
});

export const {
  useGetActiveSalesRepHiringManagersQuery,
  useCheckLeadPhoneMutation,
  useCreateCollegeLeadMutation,
  useCreateRepLeadMutation,
} = leadsApi;
